const coresFigma = {
    verde: {
        claro1: '#8CDCD1',
        claro2: '#5ECFC1',
        medio1: '#3CBFAF',

        medio2: '#2AAFA0',
        medio3: '#3AAEAE',
        escuro1: '#1A9D8F',
        escuro2: '#0F8C7E'
    },
    azul: {
        claro1: '#A8D4F4',
        claro2: '#7BBFF0',
        medio1: '#4EAAEB',
        medio2: '#2196E6',
        escuro1: '#0D82D3',
        escuro2: '#0A6EB8',
        escuro3: '#0A5A9C',
        escuro4: '#084A80'
    },
    neutras: {
        branco: '#FFFFFF',
        cinzaClaro: '#F5F5F5',
        cinzaMedio: '#E0E0E0',
        cinzaEscuro: '#757575',
        preto: '#212121'
    }
};

const coresFigmaArray = [
    // Verdes

    '#8CDCD1',
    '#5ECFC1',
    '#3CBFAF',
    '#2AAFA0',
    '#3AAEAE',
    '#1A9D8F',
    '#0F8C7E',

    // Azuis
    '#A8D4F4',
    '#7BBFF0',
    '#4EAAEB',
    '#2196E6',
    '#0D82D3',
    '#0A6EB8',
    '#0A5A9C',
    '#084A80',

    // Neutras
    '#FFFFFF',
    '#F5F5F5',
    '#E0E0E0',
    '#757575',
    '#212121'
];

const coresMescladasArray = [
    '#3AAEAE',
    '#757575', // Verde
    // Neutro escuro

    '#A8D4F4', // Azul
    '#F5F5F5',
    '#90A4AE', // Neutro

    '#59dbcb', // Verde
    '#7BBFF0', // Azul
    '#E0E0E0', // Neutro

    '#3CBFAF', // Verde
    '#4EAAEB', // Azul
    '#757575', // Neutro médio

    '#2AAFA0', // Verde
    '#2196E6', // Azul

    '#1A9D8F', // Verde
    '#0D82D3', // Azul

    '#0F8C7E', // Verde
    '#0A6EB8', // Azul

    '#0A5A9C', // Azul
    '#084A80', // Azul escuro

    '#8CDCD1' // Verde
];

export { coresFigma, coresFigmaArray, coresMescladasArray };
